import styledComp from 'styled-components';

import { OutlinedInput, Chip } from '@mui/material';
import { Styling, Colors } from '../../../../constants';

const labelWidth = 70;
const labelRightMargin = Styling.DEFAULT_SPACING;
export const listPadding = Styling.DEFAULT_SPACING_DOUBLED;
export const listHeight = 60 + listPadding;

export const UnusedNotice = styledComp.h1`
  cursor: default;
  top: ${(listHeight - listPadding) * 2}px;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  font-weight: bolder;
  font-size: 20px;
  text-transform: uppercase;
  text-align: center;
  color: ${Colors.LIGHT_GREY};

  svg {
    position: relative;
    top: 4px;
  }
`;

// Used as descriptive component namespace only now
export const DroppableContainer = styledComp.div`
`;

export const ProgressContainer = styledComp.div`
  height: ${Styling.DEFAULT_LINEAR_PROGRESS_HEIGHT}px;
`;

export const ControlContainer = styledComp.div`
  align-items: center;
  display: flex;
  margin: ${Styling.DEFAULT_SPACING}px 0 ${Styling.DEFAULT_SPACING_HALVED}px;
  padding: 0 ${Styling.DEFAULT_SPACING_DOUBLED}px;
`;

export const Label = styledComp.div`
  text-align: center;
  margin-top: 10px;
  font-size: 16px;
  &.disabled {
    opacity: 0.25;
  }
`;

export const Preview = styledComp.span`
  display: block;
  margin-top: ${Styling.DEFAULT_SPACING}px;
  margin-bottom: ${Styling.DEFAULT_SPACING_DOUBLED}px;
  font-weight: bold;
  font-size: 14px;
`;

export const Input = styledComp(OutlinedInput)`
  flex-grow: 1;
`;

export const Value = styledComp.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
`;

export const ValuesContainer = styledComp.div`
  padding: 0 ${Styling.DEFAULT_SPACING_DOUBLED + 2}px 0 ${labelWidth + labelRightMargin + Styling.DEFAULT_SPACING_DOUBLED}px;
  overflow: overlay;
`;

export const DropContainer = styledComp.div`
  overflow: hidden;
`;

export const Container = styledComp.div`
  display: flex;
  flex-wrap: wrap;
  height: 64px;
  overflow: auto;
`;

export const StyledChip = styledComp(Chip)`
margin-left 4px;
margin-top 8px;
  padding: 0 ${Styling.DEFAULT_SPACING}px 0 0;
  &.focused {
    &:focus, &:hover {
      background-color: ${Colors.DARK_RED};
    }
    background-color: ${Colors.RED_1};
    .MuiChip-label {
      color: ${Colors.WHITE_100};
      font-weight: bolder;
    }
    .MuiChip-deleteIcon {
      color: ${Colors.WHITE_100};
    }
  }
`;

export const OriginalFileNameContainer = styledComp.div`
  width: 100%;
  display: flex;
  justify-content: center;
  justify-items: center;
  & > span {
    display: inline-flex;
    align-items: center;
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    margin-right: 10px;
  }
`;
